import randomMC from "random-material-color";
import { makeStyles } from "@material-ui/core";
export default function ReportsAvatarIcon(props) {
	const classes = useStyles();
	return (
		<svg className={classes.avatar} width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M19.5 0C8.74781 0 0 8.52351 0 19C0 29.4765 8.74781 38 19.5 38C30.2522 38 39 29.4765 39 19C39 8.52351 30.2522 0 19.5 0ZM19.6875 8.76923C21.0225 8.76923 22.3276 9.15496 23.4376 9.87764C24.5476 10.6003 25.4128 11.6275 25.9237 12.8293C26.4346 14.031 26.5683 15.3534 26.3078 16.6292C26.0474 17.905 25.4045 19.0769 24.4605 19.9967C23.5165 20.9165 22.3137 21.5429 21.0044 21.7967C19.695 22.0505 18.3378 21.9202 17.1044 21.4224C15.871 20.9246 14.8168 20.0817 14.0751 19.0001C13.3334 17.9185 12.9375 16.6469 12.9375 15.3462C12.9375 13.6018 13.6487 11.929 14.9145 10.6956C16.1804 9.46216 17.8973 8.76923 19.6875 8.76923ZM19.5 35.0769C17.2242 35.0778 14.9729 34.6188 12.8884 33.7289C10.8039 32.839 8.93144 31.5376 7.38937 29.9067C8.21813 25.7249 15.6619 24.8462 19.5 24.8462C23.3381 24.8462 30.7819 25.7249 31.6106 29.9058C30.0688 31.5369 28.1964 32.8387 26.1118 33.7288C24.0273 34.6188 21.7759 35.0779 19.5 35.0769Z" />
		</svg>
	);
}

const useStyles = makeStyles((theme) => ({
	avatar: {
		"& > path": {
			fill: randomMC.getColor({ shades: ["300", "500"] }),
		},
	},
}));
